/** Characters no mainstream file system accepts in a name, plus control characters. */
export const ILLEGAL_NAME_CHARS = /[/\\:*?"<>|\u0000-\u001f]/g;

export const FALLBACK_ALBUM_NAME = 'Kizu Album';
const MAX_NAME_LENGTH = 80;

/** Turns an album title into a safe folder / ZIP base name. */
export function sanitizeAlbumName(title: string | null | undefined): string {
  const cleaned = (title ?? '')
    .replace(ILLEGAL_NAME_CHARS, ' ')
    .replace(/\s+/g, ' ')
    .replace(/^[. ]+/, '')
    .slice(0, MAX_NAME_LENGTH)
    .replace(/[. ]+$/, '');
  return cleaned || FALLBACK_ALBUM_NAME;
}

/** Folder name inside a ZIP, and the ZIP's own name minus ".zip". */
export function partFolderName(base: string, partNumber: number, isMultiPart: boolean): string {
  return isMultiPart ? `${base} (part ${partNumber})` : base;
}

/** thumbs/<media filename>.jpg — keeps the original extension so names cannot collide. */
export function thumbName(filename: string): string {
  return `${filename}.jpg`;
}

/** YYYY-MM-DD in the browser's own time zone, so an evening export is not dated tomorrow. */
export function localDate(date: Date): string {
  const two = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${two(date.getMonth() + 1)}-${two(date.getDate())}`;
}

/** Appended to a ZIP's name when it holds only items not exported before. */
export function incrementalSuffix(date: Date): string {
  return ` (new ${localDate(date)})`;
}
